module.exports = __webpack_public_path__ + "static/media/end_lesson_avatar.67525f77.svg";